/** Thin wrapper around the gateway API. Keeps fetch details out of components. */

const request = async (path, options = {}) => {
  const response = await fetch(`/api${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });

  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const message = payload?.error?.message ?? `Request failed with status ${response.status}`;
    const error = new Error(message);
    error.code = payload?.error?.code ?? 'REQUEST_FAILED';
    throw error;
  }

  return payload;
};

export const api = {
  health: () => request('/health'),
  listNodes: () => request('/nodes'),
  listCountries: () => request('/nodes/countries'),
  checkAllNodes: () => request('/nodes/check', { method: 'POST' }),
  checkUrl: (url, country) =>
    request('/check', {
      method: 'POST',
      body: JSON.stringify({ url, ...(country ? { country } : {}) }),
    }),
};

/** Mirrors the server-side encoder so the UI can build "open" links itself. */
export const encodeTarget = (targetUrl) => {
  const bytes = new TextEncoder().encode(targetUrl);
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

/**
 * The "open" button uses host-based proxying (/api/open), which redirects into a
 * per-site subdomain. That mode makes root-relative URLs and client-side routing
 * resolve to the real origin, so even Next.js/Turbopack apps render and hydrate -
 * something query-parameter proxying (/api/proxy) cannot do.
 */
export const buildOpenUrl = (targetUrl, country) => {
  const params = new URLSearchParams({ u: targetUrl });
  if (country) params.set('c', country);
  return `/api/open?${params.toString()}`;
};
